module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-message"
  }, [_c('span', {
    staticClass: "success-text"
  }, [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "success-close",
    on: {
      "click": _vm.closeMessage
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74e2347d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SuccessMessage.vue
// module id = 2166
// module chunks = 0